<div class="login-container">
  <form [formGroup]="loginForm" (ngSubmit)="login()" class="form">
    <h1>Truvideo Messaging</h1>
    <p class="login-subtitle">Access your TruVideo messaging workspace.</p>
    <mat-form-field appearance="outline" class="full-width-input">
      <mat-icon matPrefix svgIcon="email"></mat-icon>
      <input matInput formControlName="username" placeholder="{{ 'LOGIN.enterYourEmail' | translate }}" type="email" />
    </mat-form-field>
    @if (!dealerId) {
    <mat-form-field appearance="outline" class="full-width-input">
      <mat-icon matPrefix svgIcon="person"></mat-icon>
      <input matInput formControlName="dealerId" placeholder="{{ 'LOGIN.dealerID' | translate }}" type="string" />
    </mat-form-field>
    }

    <mat-form-field appearance="outline" class="full-width-input">
      <mat-icon matPrefix svgIcon="lock"></mat-icon>
      <input
        matInput
        [type]="hide() ? 'password' : 'text'"
        formControlName="password"
        placeholder="{{ 'LOGIN.enterYourPassword' | translate }}"
        autocomplete="on" />
      <mat-icon
        [svgIcon]="hide() ? 'eye-slash' : 'eye'"
        class="visibility-icon"
        matSuffix
        (click)="togglePasswordVisibility()"></mat-icon>
    </mat-form-field>
    @if (loginError()) {
    <p class="error">{{ 'LOGIN.invalidData' | translate }}</p>
    }
    <button type="submit" [disabled]="isLoading() || loginForm.invalid" mat-raised-button color="primary">
      @if (!isLoading()) { Login } @else {
      <mat-spinner [diameter]="20"></mat-spinner>
      }
    </button>
    <p class="forgot-password">
      {{ 'LOGIN.forgotPassword' | translate }}
      <a [href]="forgotPasswordUrl" target="_blank">{{ 'LOGIN.clickHere' | translate }}</a>
    </p>
  </form>
</div>
